// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import VuePromiseBtn from 'vue-promise-btn'
import BootstrapVue from "bootstrap-vue";
import VueSwal from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import App from './App';
import router from './router';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
//Font awesome
import { BootstrapVueIcons } from 'bootstrap-vue';
import 'bootstrap-vue/dist/bootstrap-vue-icons.min.css';
import store from '@/store';
import VueAxios from 'vue-axios';
import axios from '@/axios';
import FullCalendar from 'vue-full-calendar';
import VueLoading from "vue-loading-overlay";
import 'vue-loading-overlay/dist/vue-loading.css';

import VueCalendarHeatmap from 'vue-calendar-heatmap'

import { ValidationObserver,extend, ValidationProvider, localize } from 'vee-validate';
import * as rules from "vee-validate/dist/rules";
import es from "vee-validate/dist/locale/es.json";

import JsonExcel from "vue-json-excel";

Vue.component("downloadExcel", JsonExcel);

Object.keys(rules).forEach(rule => {
  console.log(rule);
  extend(rule, rules[rule]);
});
localize("es", es);
Vue.component("ValidationObserver", ValidationObserver);
Vue.component('ValidationProvider', ValidationProvider);


Vue.use(VueCalendarHeatmap)




Vue.use(FullCalendar);
Vue.use(BootstrapVue);
Vue.use(VuePromiseBtn, {});
Vue.config.productionTip = false;
Vue.use(require('vue-moment'));
Vue.use(VueSwal);


Vue.use(VueAxios, axios)

Vue.use(BootstrapVueIcons);

Vue.use(VueLoading, {
  // props
  color: 'blue',
  //text: "Procesando consulta"
},{
  // slots
})
/* eslint-disable no-new */
const app =new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App },
  store
});

export { app, router, store }



// WEBPACK FOOTER //
// ./src/main.js